/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Edit_Min_WidthInputs */

const en_forms_rule_sets_edit_min_width = /** @type {(inputs: Forms_Rule_Sets_Edit_Min_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min Width`)
};

const de_forms_rule_sets_edit_min_width = /** @type {(inputs: Forms_Rule_Sets_Edit_Min_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min Breite`)
};

/**
* | output |
* | --- |
* | "Min Width" |
*
* @param {Forms_Rule_Sets_Edit_Min_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_edit_min_width = /** @type {((inputs?: Forms_Rule_Sets_Edit_Min_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Edit_Min_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_edit_min_width(inputs)
	return de_forms_rule_sets_edit_min_width(inputs)
});